import InputPhone from 'react-phone-input-2'
import { CSSProperties, FC, FocusEvent, useState } from 'react'
import cn from 'classnames'
import { isValidPhoneNumber } from 'libphonenumber-js'
import ReactCountryFlag from 'react-country-flag'

type CountryData = {
  countryCode?: string
}

type PhoneInputProps = {
  className?: string
  'data-test'?: string
  disabled?: boolean
  id?: string
  isValid?: boolean
  name?: string
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void
  onChange?: (value: string) => void
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void
  required?: boolean
  touched?: boolean
  value?: string
}

const DEFAULT_COUNTRY = 'gb'

const customFlagStyle: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  left: 12,
  pointerEvents: 'none',
  position: 'absolute',
  top: 10,
}

const PhoneInput: FC<PhoneInputProps> = ({
  className,
  disabled,
  id,
  isValid,
  name,
  onBlur,
  onChange,
  onFocus,
  required,
  touched,
  value,
}) => {
  const [hasBlurred, setHasBlurred] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY)

  const handleFocus = (e: FocusEvent<HTMLInputElement>, _data: CountryData) => {
    setIsFocused(true)
    onFocus?.(e)
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>, _data: CountryData) => {
    setHasBlurred(true)
    setIsFocused(false)
    onBlur?.(e)
  }

  const isValidNumber = !value
    ? !required
    : value.length <= 3 || isValidPhoneNumber(value)

  const showError =
    (hasBlurred || touched) && (isValid === false || !isValidNumber)

  return (
    <div
      className={cn(
        'phone-input-wrapper position-relative',
        { focused: isFocused, invalid: showError },
        className,
      )}
    >
      <div aria-hidden className='custom-flag' style={customFlagStyle}>
        <ReactCountryFlag
          svg
          countryCode={countryCode.toUpperCase()}
          style={{
            height: '16px',
            marginTop: 4,
            width: '16px',
          }}
        />
      </div>

      <InputPhone
        buttonClass='hide-native-flag'
        country={DEFAULT_COUNTRY}
        disabled={disabled}
        inputProps={{
          className: 'form-control',
          id,
          name,
        }}
        onBlur={handleBlur}
        onChange={(v, country: CountryData, _e, formattedValue) => {
          if (country?.countryCode) setCountryCode(country.countryCode)
          const formatted = (formattedValue ?? v).replace(/ /g, '')
          onChange?.(formatted)
        }}
        onFocus={handleFocus}
        onMount={(_v, country: CountryData) => {
          if (country?.countryCode) setCountryCode(country.countryCode)
        }}
        preferredCountries={[DEFAULT_COUNTRY]}
        specialLabel=''
        value={value}
      />
    </div>
  )
}

export default PhoneInput
